import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import CssBaseline from '@material-ui/core/CssBaseline';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import Paper from '@material-ui/core/Paper';

import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './CompanyScreenStyles';
import CompanyForm from 'app/components/CompanyForm';
import CompanyTableContainer from 'app/containers/CompanyTableContainer';

import { useDispatch } from 'react-redux';
import { companyClear } from 'app/actions/CompanyActions';

export default function CompanyScreen(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [pagination, setPagination] = useState({ defaultCurrent: 1, defaultPageSize: 25, pageSize: 25, total: 0, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'], showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`  });
    const [sorter, setSorter] = useState({});
    const [formData, setFormData] = useState({});
    const [filter, setFilter] = useState([]);
    const [idClient, setIdClient] = useState(0);
    const [visibleForm, isVisibleForm] = useState(false)
    const [nameClient, setNameClient] = useState(''); 
    const [FiltroCompany, setFiltroCompany] = useState([]);

    useEffect(() => {
        return () => {
            dispatch(companyClear());
        }
    }, []);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} header='Compañía' isCommunicationStatus={false}/>
            <CssBaseline />
            <div className={`${classes.content}`}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label="Breadcrumb">
                        <Link color="inherit" disabled>
                           Compañía
                            </Link>
                        <TextEvents
                            text="Catálogo de Compañías"
                            color="cotemar"
                            size='subtitle'
                            weight="bold"
                        />
                    </Breadcrumbs>
                </div>
                <Paper className={classes.rootPaper}>
                    <CompanyForm idClient={idClient} setIdClient={setIdClient} nameClient={nameClient} setNameClient={setNameClient} visibleForm={visibleForm} isVisibleForm={isVisibleForm}  filter={filter} setFilter={setFilter} pagination={pagination} sorter={sorter} formData={formData} setFormData={setFormData} FiltroCompany={FiltroCompany} setFiltroCompany={setFiltroCompany}/>
                    <div style={styles.baseVerticalMargin}>
                        <CompanyTableContainer setIdClient={setIdClient} setNameClient={setNameClient} isVisibleForm={isVisibleForm} classes={classes} filter={filter} sorter={sorter} setSorter={setSorter} pagination={pagination} setPagination={setPagination} formData={formData} FiltroCompany={FiltroCompany} setFiltroCompany={setFiltroCompany}>
                            {(params) => {
                                return (
                                    <div>
                                        <Table
                                            loading={params.isLoading}
                                            rowKey={item => String(item.idClient)}
                                            columns={params.cols}
                                            dataSource={params.company}
                                            onChange={params.handleTableChange}
                                            pagination={pagination}
                                            //scroll={{ y: 700, x: "min-content" }}
                                            scroll={{ x: 'min-content', y: (height - 440) }}
                                            size={"small"}
                                        />
                                    </div>
                                )
                            }}
                        </CompanyTableContainer>
                    </div>
                </Paper>


                </div>
            </div>
         )
}